import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError, AxiosInstance } from 'axios';
import { addActionNameToMutationResult } from 'shared/hooks/utils/add-action-name-to-mutation-result';
import { useAxiosInstance } from 'shared/hooks/utils/axios-instance';
import type { ApiResponse } from 'shared/hooks/utils/types';
import { z } from 'zod/v4';

const UpdateIgnoredDebtorsVariablesSchema = z.array(z.string());
export type UpdateIgnoredDebtorsVariables = z.infer<typeof UpdateIgnoredDebtorsVariablesSchema>;

export async function updateIgnoredDebtors(
  axiosInstance: Promise<AxiosInstance>,
  data: UpdateIgnoredDebtorsVariables,
) {
  const instance = await axiosInstance;
  return instance.put(`accounting_details/ignored_import_debtors`, data);
}

export function useUpdateIgnoredDebtors() {
  const axiosInstance = useAxiosInstance();
  const client = useQueryClient();

  const mutation = useMutation<
    ApiResponse,
    AxiosError<{ error_message: Array<string> }>,
    UpdateIgnoredDebtorsVariables
  >({
    mutationFn: variables => updateIgnoredDebtors(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['company-configuration'] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    AxiosError<{ error_message: Array<string> }>,
    UpdateIgnoredDebtorsVariables,
    'updateIgnoredDebtors'
  >('updateIgnoredDebtors', mutation);
}
